import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'alertTypePipe'
})
export class AlertTypePipePipe implements PipeTransform {

  transform(value: any){
    if (value === 1) {
      return "Injury/Accident";
    }
    else if (value === 2) {
      return "Medical Assistance";
    }
    else if (value === 3) {
      return "Vehicle Break down";
    }
    else if (value === 4) {
      return "Suspicious Route";
    }
    else if (value === 5) {
      return "Rash Driving";
    }
    else if (value === 6) {
      return "Misconduct";
    }
  }

}
